import React, { useState, useEffect } from 'react';
import Select from "react-select";
import axios from 'axios';
import "antd/dist/antd.css";
import { DatePicker } from 'antd';
import moment from 'moment';
import { Line } from 'react-chartjs-2';
import './ActiveLocations.css';
import { baseURL } from './backend_url';
import { Button } from 'react-bootstrap';
import Swal from "sweetalert2";

// Import necessary components from Chart.js
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register necessary components with Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function Report() {
  const [companyName, setCompanyName] = useState("Routes Car Rental");
  const [companyId, setCompanyId] = useState("690337");
  const [locationDetail, setLocationDetail] = useState([]);
  const [locationName, setLocationName] = useState("");
  const [locationId, setLocationId] = useState("");
  const [savedData, setSavedData] = useState([]);
  const [hashLocationNameVsID, setHashLocationNameVsID] = useState({});
  const [startDate, setStartDate] = useState(new Date(new Date() - 1000 * 60 * 60 * 24*7));
  const [endDate, setEndDate] = useState(new Date());
  const [reportData, setReportData] = useState(null);
  const [reportFailedData, setReportFailedData] = useState(null);
  const [fetchFailedCasesClicked, setFetchFailedCasesClicked] = useState(false);

  useEffect(() => {
    const companyIdTemp = '690337';
    setCompanyId(companyIdTemp);
    setSavedData([]);
    const loggedInUser = sessionStorage.getItem("user_token");
      const foundUser = JSON.parse(loggedInUser);
    axios.get(baseURL + "/get_company_location/" + companyIdTemp)
      .then((res) => {
        axios.get(baseURL + "/srt_get_active_location/" + companyIdTemp.toString())
          .then((res1) => {
            axios.get(baseURL + "/srt_get_user_location/" + foundUser.userEmail)
                .then((res2) => {
                  const assigned_location_hash = res2.data;
            let allTemp = res.data.res;
            let hashLocationNameId = {};
            allTemp.forEach((k) => hashLocationNameId[k.location_id] = k.location_name);
            setHashLocationNameVsID(hashLocationNameId);
            if (allTemp.length > 0) {
              let tempArr = [];
              for (let i = 0; i < allTemp.length; i++) {
                if(foundUser.role === 'Users'){
                if (res1.data[allTemp[i].location_id] === true && assigned_location_hash[allTemp[i].location_id] === true) {
                  tempArr.push(allTemp[i]);
                }
              }
              else{
                if (res1.data[allTemp[i].location_id] === true) {
                  tempArr.push(allTemp[i]);
                }
              }
              }
              setLocationDetail(tempArr);
            }
          })
          });
      });
  }, []);

  const handleInputChangeLocationName = (selectedOption) => {
    setLocationName(hashLocationNameVsID[selectedOption.value]);
    const locationId = selectedOption.value;
    setLocationId(locationId);

    axios.get(`${baseURL}/srt_get_vehicle_data/${locationId}`)
      .then((response) => {
        const vehicleData = response.data.vehicles || [];
        setSavedData(vehicleData);
      })
      .catch((error) => {
        console.error("Error fetching vehicle data:", error);
        setSavedData([]);  // Clear savedData in case of error
      });
  };

  const handleFetchReport = () => {
    if (locationId && startDate && endDate) {
      axios.post(`${baseURL}/srt_fetch_report`, {
        locationId: locationId,
        startDate: new Date(startDate).toDateString(),
        endDate: new Date(endDate).toDateString()
      })
        .then((response) => {
          setReportData(response.data);

          setFetchFailedCasesClicked(false);
        })
        .catch((error) => {
          console.error("Error fetching report data:", error);
          setReportData(null);  // Clear reportData in case of error
        });
    }
  };
  const handleFetchFailedCases = () => {
    if (!startDate && !endDate) {
      Swal.fire("Failed", "Please select Start and end date to proceed ahead", "error");
      return;
    }
    if (startDate && endDate) {
      axios.post(`${baseURL}/srt_fetch_failed_requests`, {
        startDate: new Date(startDate).toDateString(),
        endDate: new Date(endDate).toDateString()
      })
        .then((response) => {
          setReportFailedData(response.data);
          setFetchFailedCasesClicked(true);
        })
        .catch((error) => {
          console.error("Error fetching failed cases data:", error);
          setReportFailedData(null);  // Clear reportData in case of error
        });
    }
  };

  const getChartData = () => {
    if (!reportData) return null;

    const dates = Object.keys(reportData.requestsByDate)
      .sort((a, b) => new Date(a) - new Date(b));
    const requestsData = dates.map(date => reportData.requestsByDate[date] || 0);
    const requestsDataUnique = dates.map(date => reportData.requests_by_date_unique[date] || 0);

    return {
      labels: dates,
      datasets: [
        {
          label: 'Number of Requests',
          data: requestsData,
          fill: false,
          backgroundColor: 'rgba(75, 192, 192, 0.6)',
          borderColor: 'rgba(75, 192, 192, 1)',
        },
        {
          label: 'Number of Unique Requests',
          data: requestsDataUnique,
          fill: false,
          backgroundColor: '#FF6000',
          borderColor: '#FF6000',
        },

      ],
    };
  };

  const getChartDataFailed = () => {
    if (!reportFailedData) return null;

    // const dates = Object.keys(reportFailedData.Reservation_Number_not_Correct).sort();
    // Extract all unique dates from the report data
    const allDates = new Set([
      ...Object.keys(reportFailedData.Reservation_Number_not_Correct),
      ...Object.keys(reportFailedData.Last_Name_not_Correct),
      ...Object.keys(reportFailedData.All_entered_data_are_incorrect),
      ...Object.keys(reportFailedData.Drop_Off_date_passed),
      ...Object.keys(reportFailedData.PickUp_points_not_defined),
      ...Object.keys(reportFailedData.Location_not_Active),
    ]);

    // Convert the Set to an array and sort the dates
    const dates = Array.from(allDates)
      .sort((a, b) => new Date(a) - new Date(b));

    const Reservation_Number_not_Correct = dates.map(date => reportFailedData.Reservation_Number_not_Correct[date] || 0);
    const Last_Name_not_Correct = dates.map(date => reportFailedData.Last_Name_not_Correct[date] || 0);
    const All_entered_data_are_incorrect = dates.map(date => reportFailedData.All_entered_data_are_incorrect[date] || 0);
    const Drop_Off_date_passed = dates.map(date => reportFailedData.Drop_Off_date_passed[date] || 0);
    const PickUp_points_not_defined = dates.map(date => reportFailedData.PickUp_points_not_defined[date] || 0);
    const Location_not_Active = dates.map(date => reportFailedData.Location_not_Active[date] || 0);

    return {
      labels: dates,
      datasets: [
        {
          label: 'Reservation Number not Correct',
          data: Reservation_Number_not_Correct,
          fill: false,
          backgroundColor: 'rgba(75, 192, 192, 0.6)',
          borderColor: 'rgba(75, 192, 192, 1)',
        },
        {
          label: 'Last Name not Correct',
          data: Last_Name_not_Correct,
          fill: false,
          backgroundColor: '#4CAF50',
          borderColor: '#4CAF50',
        },
        {
          label: 'Drop-Off date passed',
          data: Drop_Off_date_passed,
          fill: false,
          backgroundColor: '#FBD83B',
          borderColor: '#FBD83B',
        },
        {
          label: 'All entered data are incorrect',
          data: All_entered_data_are_incorrect,
          fill: false,
          backgroundColor: '#FF6000',
          borderColor: '#FF6000',
        },
        {
          label: 'PickUp points not defined',
          data: PickUp_points_not_defined,
          fill: false,
          backgroundColor: '#BA68C8',
          borderColor: '#BA68C8',
        },
        {
          label: 'Location not Active',
          data: Location_not_Active,
          fill: false,
          backgroundColor: '#0F1B35',
          borderColor: '#0F1B35',
        },
      ],
    };
  };

  return (
    <div className="container mt-1">
      <div className="p-5 bg-light rounded shadow-sm">
        <h4 className="text-primary mb-4">Report</h4>

        {companyName && (
          <>

            <div className="mb-4">
              <label htmlFor="location_name" className="form-label">
                Select Location
              </label>
              <Select
                value={{ value: locationName, label: (locationName ? locationName : "Select Location Name") }}
                inputId="location_name"
                name="location_name"
                options={locationDetail.map(location => ({
                  value: location.location_id,
                  label: `${location.location_name} - ${location.location_id.split('-')[1]}`
                }))}
                onChange={handleInputChangeLocationName}
              />
            </div>

            <div className="mb-4">
              <label className="form-label">Select Date Range</label>
              <div className="d-flex">
                <DatePicker size="large" format='MM-DD-YYYY' placeholder='mm-dd-yyyy' onChange={(date, dateString) => {
                  setStartDate(date);
                }}
                  style={{ width: '100%', position: 'relative' }}
                  value={startDate ? moment(new Date(startDate)) : startDate}

                  getPopupContainer={(triggerNode) => {
                    return triggerNode.parentNode;
                  }}
                />

                <DatePicker size="large" format='MM-DD-YYYY' placeholder='mm-dd-yyyy' disabledDate={(current) => {
                  if (startDate) {
                    return current && current.valueOf() < startDate.valueOf();
                  }
                }} onChange={(date, dateString) => setEndDate(date)} style={{ width: '100%' }}
                  value={endDate ? moment(new Date(endDate)) : endDate}

                  getPopupContainer={(triggerNode) => {
                    return triggerNode.parentNode;
                  }}
                />
              </div>
            </div>

            <div className='row'>
              <div className='col-6'>
                {locationName &&
                  <Button className="mb-3" onClick={handleFetchReport}>Fetch Report</Button>
                }
              </div>
              <div className='col-6 d-flex justify-content-end'>
                <Button className="mb-3" onClick={handleFetchFailedCases}>Fetch Failed Cases</Button>
              </div>
            </div>

            {(reportData || reportFailedData) && (
              <div className="mt-4">
                <div className='row'>
                  {!fetchFailedCasesClicked ?
                    <div className='col-md-4'>
                      <h5>Report Data</h5>
                      <table className='table table-dark table-striped table-hover table-bodered'>
                        <tbody>
                          <tr>
                            <td>Number of Requests: </td>
                            <td >{reportData.numberOfTotalRequests}</td>
                          </tr>
                          <tr>
                            <td>Number of Unique Requests: </td>
                            <td >{reportData.numberOfUniqueRequests}</td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                    :
                    <div className='col-md-4'>
                      <h5>Report Data - Failed Cases</h5>
                      <span>Note: All locations failed cases.</span>
                      <table className='table table-dark table-striped table-hover table-bodered pt-3'>
                        <tbody>
                          <tr>
                            <td>Total Failed Cases:</td>
                            <td >{reportFailedData.number_of_failed_requests}</td>
                          </tr>


                        </tbody>
                      </table>
                    </div>
                  }
                </div>
                {/* Add other insights here */}
                {!fetchFailedCasesClicked ?
                  <Line data={getChartData()} />
                  :
                  <Line data={getChartDataFailed()} />
                }
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Report;
